export default "__VITE_ASSET__C$YArdPS__"